import React from "react";
// import specific_location_img from "../../images/delhi.jpg";
import { useNavigate } from "react-router-dom";

import ChatButton from "../../components/ChatButton";
import { APP_NAME } from "../../Utils/constant";
import { handleApplyNow } from "../../Utils/navigation";

const Delhi = () => {
  const navigate = useNavigate();
  return (
    <>

      <div className="content_page_wrapper">
        <div className="content_page_banner_wrapper delhi_banner">
          <div className="content_page_banner_wrapper_overlay">
            <h2>Location - New Delhi</h2>
          </div>
        </div>

        <div className="text_content_wrapper">
          <div className="text_content">
            {/* <div className="content_banner">
                <img src={specific_location_img} alt="" />
              </div> */}
            <h1 className="page_title mt30 mb20">
            Instant Personal Loan Online for Salaried Employees in Delhi
            </h1>
            <p>
            Delhi, the capital of India, has been upbringing and nurturing many lives on its soil for ages. Apart from local residents, this affluent and traditionally rich city is home to millions of people coming from different parts of the country. In addition, Delhi is a go-to city for tourists arriving from various nooks and corners of the world. An essential question is, why does Delhi receive such a massive footfall?

The answer to this question is that this city has so much to offer — Metro, MNCs, lavish shopping malls, cultural heritages, mouth-watering momos, and whatnot.

However, with amazing positives comes a few challenges, including hefty expenses. Whether you go sightseeing or crave to eat something delicious, whether you travel via metro or rent a decent room for accommodation, heavy expenses are part and parcel of this metropolitan city. The next important question is what to do if one runs short of money in between. How will the expenses be managed then?

            </p>
            <br />
            <h3 className="mb10">Features and Benefits</h3>
            <ul className="content_list">
              <li>
                <b>Fully Online Process:</b> Apply online with minimal
                documentation.
              </li>
              <li>
                <b>Quick Verification:</b> Rapid processing and eligibility
                assessment.
              </li>
              <li>
                <b>Collateral-Free Loans: </b> No security required.
              </li>
              <li>
                <b>Predictable Payments:</b> Flexible repayment options.
              </li>
              <li>
                <b>Instant Disbursal:</b> Funds transferred immediately upon
                approval.
              </li>
              <li>
                <b>All Credit Ratings Considered:</b> Low credit scores are also
                eligible.
              </li>
            </ul>
            <br />
            <h3 className="mb10">
            Instant Personal Loan for Salaried Professions
            </h3>
            <p>
            Undoubtedly, running out of money is common here. However, instant personal loan online for salaried professionals is a unique solution to address this recurring problem. If you are somebody who is a working professional, you can easily get an instant personal loan from RBI-registered NBFC {APP_NAME}, the best instant personal loan app in India, to effectively manage your expenses or resume your halted activities.

            </p>
            <h3>Who is Eligible for Taking an Instant Personal Loan?</h3>
            <p className="mt6">
            As discussed, {APP_NAME} offers instant personal loans online to those who are working professionals. Irrespective of whether you work in corporate or non-corporate, we have got you covered. We have detailed the prerequisites below which are necessary for taking a loan. Let’s go through them one by one in detail.
            </p>
            <ul className="content_list">
              <li>First and foremost, the concerned person willing to take an instant personal loan in Delhi must be a resident of India. You must have relevant documents enough to prove your Indian nationality. Any non-resident of India, including tourists is not eligible to avail our loan services.</li>
              <li>Any working professional with a monthly in-hand salary of at least 25000 can easily get personal loan instant approval.</li>
              <li>Lastly, anyone aged between 21 to 51 years can get an online personal loan instantly.</li>
            </ul>
            <h3>Instant Personal Loan Apply: What Documents are Required?</h3>
            <p className="mt6">
            Typically, loan application in India is considered a tedious and time-consuming process, requiring a bundle of documents to prove your credibility. In contrast, we have broken the stereotype by asking for minimal documents to apply for — an instant small personal loan, emergency personal loan, short-term loan, long-term loan, etc at {APP_NAME}. Here is a list of the documents you need to have before personal loan online apply.
            </p>
            <ul className="content_list">
              <li>Identity Proof (such as Aadhar card, Voter card, etc)</li>
              <li>Address proof</li>
              <li>PAN card</li>
              <li>Income Proof (such as Salary Slip, Bank Statement, etc)</li>
              <li>Passport-sized photographs</li>
            </ul>
            <h3>Final Words</h3>
            <p className="mt6">
            Having the above-mentioned documents can be a ticket to getting your loan approved in minutes. If you are a good fit as per the eligibility criteria and possess the necessary documents, {APP_NAME} is your go-to financial partner in urgent needs. VISIT OUR WEBSITE TO APPLY FOR A LOAN NOW.
            </p>
            <div className="button_container flex justify-center mt30">
              <button onClick={() => handleApplyNow(navigate)} className="button_container Link">Apply Now</button>
            </div>
          </div>
        </div>
      </div>
      <ChatButton />
    </>
  );
};

export default Delhi;
